import React from "react";

/**
 * Persistent ribbon that appears at the top of every page when the URL host
 * matches the Emergent preview domain. Production (custom domain
 * `odrsys.pro-pac-pa.com` and the `emergent.host` deployment) sees nothing.
 *
 * Purpose (Round-22 mandate):
 * - prevent accidental "did I just import test data into production?" panics
 * - provide a one-glance signal that any record created here is test/dev data
 *
 * Detection is purely client-side via window.location.hostname. No API
 * round-trip, no server flag.
 */
function isPreviewHostname() {
    if (typeof window === "undefined") return false;
    const host = window.location.hostname || "";
    return (
        host.endsWith(".preview.emergentagent.com")
        || host === "localhost"
        || host === "127.0.0.1"
    );
}

export default function EnvironmentBanner() {
    if (!isPreviewHostname()) return null;

    return (
        <div
            data-testid="env-banner-preview"
            role="alert"
            className="sticky top-0 z-[60] w-full bg-amber-500 text-amber-950 border-b-2 border-amber-700 shadow-sm"
            style={{ letterSpacing: "0.08em" }}
        >
            <div className="px-4 py-1.5 text-center text-[11px] font-bold uppercase odr-mono">
                ⚠ Preview Environment — Test Data Only. Production lives at{" "}
                <a
                    href="https://odrsys.pro-pac-pa.com"
                    target="_blank"
                    rel="noreferrer"
                    className="underline hover:text-amber-900"
                >
                    odrsys.pro-pac-pa.com
                </a>
            </div>
        </div>
    );
}
